import { atom } from 'jotai';

export const atom_uploadPopShotDialogLineItem = atom<string>('');
export const atom_uploadPopShotDialog = atom<boolean>(false);
export const atom_popShotHasProShots = atom<boolean>(false);
export const atom_popShotShowPro = atom<boolean>(false);
